/* eslint-disable no-nested-ternary */
import React, { useCallback, useState } from 'react';
import { Row, Col } from 'reactstrap';
import { Field } from 'react-final-form';
import _ from 'lodash';

import { AudioPlayer, Intl, LocalTable } from 'components';
import { required } from 'config/InputErrors';
import { useSelector } from 'react-redux';

const SingleFile = ( { data, field } ) => {
  const refAudio1 = React.createRef();
  const userData = useSelector( ( state ) => state.user );
  const { locale } = useSelector( ( state ) => state.settings.locale );
  const [localError, setLocalErrors] = useState( null );

  const errMsg = useCallback(
    ( seconds ) => {
      if ( locale === 'en' ) {
        return `This audio should take less than ${seconds} seconds`;
      }
      return `Este audio no debe superar los ${seconds} segundos`;
    },
    [locale],
  );
  return (
    <Field name={field} validate={required}>
      {( { input } ) => (
        <>
          <Row className="my-3">
            <Col md={8} className="campaign-wizard-table campaign-wizard-table-w-100  m-auto">
              <LocalTable
                data={data.length < 5
                  ? data.concat( new Array( 5 - data.length )
                    .fill( { empty: true } ) )
                  : data}
                manualPagination
                onlyTable
                getRowProps={( row ) => ( {
                  onClick: () => {
                    const fileLimit = field === 'singleFile'
                      ? userData && userData.simpleMessageLimit
                      : field === 'introductionFile'
                        ? userData && userData.introLimit
                        : field === 'optionsFile'
                          ? userData && userData.optionsLimit
                          : field === 'farewellFile'
                            ? userData && userData.farewellLimit
                            : ( userData.simpleMessageLimit || 60 );

                    if ( row.original && row.original.id ) {
                      if (
                        fileLimit
                          ? row.original.time > fileLimit
                          : row.original.time > 60
                      ) {
                        input.onChange( null );
                        setLocalErrors(
                          errMsg( userData && fileLimit ? fileLimit : 60 ),
                        );
                      } else {
                        if ( _.get( refAudio1.current, 'context.media' ) ) refAudio1.current.context.media.stop();
                        input.onChange( row.original );
                        setLocalErrors( null );
                      }
                    }
                  },
                  className: input.value && input.value.id === row.original.id ? 'bg-orange-6' : '',
                } )}
                columns={[
                  {
                    Header: 'availableFiles',
                    // accessor: 'originalName',
                    accessor:(row) => row.userDefineName || row.originalName,
                    style: { textAlign: 'left' },
                  },
                ]}
              />
            </Col>
          </Row>

          <Row>
            <Col md={8} className="m-auto">
              <AudioPlayer
                ref={refAudio1}
                src={input.value ? input.value.uri : ''}
              />
            </Col>
          </Row>

          {!!localError && (
            <div className="error mt-1 text-md text-center">
              {localError.indexOf( ' ' ) >= 0 ? (
                localError
              ) : (
                <Intl id={localError} />
              )}
            </div>
          )}
        </>
      )}
    </Field>
  );
};

export default SingleFile;
